// extracted by mini-css-extract-plugin
module.exports = {"comments":"styles_comments__FwTt2","commentIntro":"styles_commentIntro__I44V0"};